import type { Types as AblyTypes } from 'ably';

export interface ConnectionState {
  channelName: string | null;
  channelNameCustomer: string | null;
  ablyStatus: ConnectionStatusType;
  ablyCustomerStatus: CustomerConnectionStatusType;
  localServerStatus: ConnectionStatusType;
  error: ConnectionError | null;
}

export enum CONNECTION_STATUS {
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  READY = 'ready',
  SUSPENDED = 'suspended',
  FAILED = 'failed',
  DOWNLOAD = 'download',
}

export type ConnectionStatusType = 'connected' | 'disconnected' | 'ready';

export type CustomerConnectionStatusType = 'connected' | 'disconnected' | 'ready' | 'unavailable';

export type TrayStatusType = 'default' | 'connected' | 'disconnected' | 'ready' | 'download';

export enum MEMBER_TYPE {
  Retail = 'RETAIL',
  CFD = 'CFD',
  HUB = 'HUB',
  Customer = 'CUSTOMER',
}

export interface ConnectionError {
  state: 'unknown' | AblyTypes.ConnectionState;
  message: string | undefined;
  code: number | undefined;
  statusCode: number | undefined;
  cause: string | undefined;
}
